import Header from "@/components/Header";
import Seo from "@/components/Seo";
import ContactBar from "@/components/ContactBar";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { sz, txt, useContent } from "@/content/ContentContext";
import { buildLegalFaqs, resolveFaqs } from "@/content/faqData";
import { PAGE_META, breadcrumbSchema } from "@/content/seoData";

const LegalPage = ({ slug }) => {
  const c = useContent();
  const page = c.legal[slug];

  return (
    <div className="App">
      <Seo
        title={PAGE_META.legal[slug].title}
        description={PAGE_META.legal[slug].description}
        path={`/${slug}`}
        schemas={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: PAGE_META.legal[slug].title, path: `/${slug}` },
          ]),
        ]}
      />
      <Header />
      <main>
        <section className="svcpage-hero">
          <Reveal className="svcpage-hero-inner" y={18}>
            <h1 className="svcpage-title" style={sz(page.titleStart)} data-testid="page-title">
              {txt(page.titleStart)}{" "}
              <span className="text-green" style={sz(page.titleAccent)}>{txt(page.titleAccent)}</span>
            </h1>
            <p className="svcpage-intro" style={sz(page.intro)}>{txt(page.intro)}</p>
            <span className="legal-updated" style={sz(page.updated)} data-testid="legal-updated">
              {txt(page.updated)}
            </span>
          </Reveal>
        </section>

        <section className="post-body">
          <Reveal
            as="article"
            className="post-content legal-content"
            data-testid={`legal-content-${slug}`}
            y={22}
          >
            {page.sections.map((section, index) => (
              <div className="legal-section" key={index}>
                <h2 className="legal-heading" style={sz(section.heading)}>{txt(section.heading)}</h2>
                {section.paragraphs.map((paragraph, paragraphIndex) => (
                  <p className="post-para" key={paragraphIndex}>
                    {paragraph}
                  </p>
                ))}
                {section.bullets && section.bullets.length > 0 && (
                  <ul className="legal-bullets">
                    {section.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </Reveal>
        </section>
        <FAQSection items={resolveFaqs(c, `legal:${slug}`, buildLegalFaqs(slug, c))} />
      </main>
      <ContactBar />
      <Footer />
    </div>
  );
};

export default LegalPage;
